import { render, staticRenderFns } from "./PendingWithdrawals.vue?vue&type=template&id=5cff65bc"
import script from "./PendingWithdrawals.vue?vue&type=script&lang=js"
export * from "./PendingWithdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports